<script setup lang="ts">
import model from '@/ts/model.ts';
import UnknownFlag from '@/assets/flags/unknown.png?url';
import { ref } from 'vue';

const props = defineProps<{flag: string, size?: number, sizeMobile?: number}>();

const flagVal = ref<string>('');

function getSize(){
    return (model.isMobile ? (props.sizeMobile || props.size) : props.size) + 'px';
}

const vGetFlag = {
    mounted: updateFlag,
    updated: updateFlag,
};

async function updateFlag(){
    let iso = props.flag;
    if(iso.length == 2) iso = iso.toUpperCase();

    let url = UnknownFlag;

    try{
        url = (await import(`@/assets/flags/${iso}.png?url`))?.default;
    }
    catch(e){
        console.warn("Flag exception: " + e);
    }

    flagVal.value = url;
}

</script>

<template>
    <div 
        v-get-flag
        :style="{
            backgroundImage: flagVal && `url(${flagVal})`, 
            width: getSize(), 
            height: getSize(),
        }" 
        class="flag"
    ></div>
</template>

<style lang="scss" scoped>
    .flag {
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
</style>